import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const RouteTitleUpdater = () => {
    const location = useLocation();

    useEffect(() => {
        switch (location.pathname) {
            case '/':
                document.title = 'Добро пожаловать — Личный кабинет Альянс';
                break;
            case '/home':
                document.title = 'Главная — Личный кабинет Альянс';
                break;
            case '/account':
                document.title = 'Анкета — Личный кабинет Альянс';
                break;
            case '/essential-data':
                document.title = 'Согласие на обработку персональных данных — Личный кабинет Альянс';
                break;
            case '/membership-fees':
                document.title = 'Членские взносы — Личный кабинет Альянс';
                break;
            case '/applications':
                document.title = 'Мои заявки — Личный кабинет Альянс';
                break;
            case '/inbox':
                document.title = 'Уведомления — Личный кабинет Альянс';
                break;
            case '/procedures':
                document.title = 'Процедуры — Личный кабинет Альянс';
                break;
            case '/proposed-cases':
                document.title = 'Витрина заявок — Личный кабинет Альянс';
                break;
            case '/registers':
                document.title = 'Реестры — Личный кабинет Альянс';
                break;
            case '/users':
                document.title = 'Пользователи — Личный кабинет Альянс';
                break;
            case '/additional-admin-settings':
                document.title = 'Дополнительные настройки системы — Личный кабинет Альянс';
                break;

            case '/add-new-case':
                document.title = 'Добавление вх.корреспонденции — Личный кабинет Альянс';
                break;
            case '/add-new-debtor':
                document.title = 'Добавление должника — Личный кабинет Альянс';
                break;

            case '/auth/login':
                document.title = 'Вход — Личный кабинет Альянс';
                break;
            case '/auth/registration':
                document.title = 'Регистрация — Личный кабинет Альянс';
                break;
            case '/view-feedback':
                document.title = 'Просмотр обращений обратной связи — Личный кабинет Альянс';
                break;
            case '/auth/logout':
                document.title = 'Выполняется выход — Личный кабинет Альянс';
                break;
            case '/legal/terms-of-use':
                document.title = 'Пользовательское соглашение — Личный кабинет Альянс';
                break;
            case '/legal/privacy-policy':
                document.title = 'Политика конфиденциальности — Личный кабинет Альянс';
                break;
            default:
                document.title = 'Личный кабинет Альянс';
        }
    }, [location]);

    return null;
};

export default RouteTitleUpdater;
